import { useState, useEffect } from 'react';
import { Typography, Collapse, Skeleton, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import { useNavigate, useParams } from 'react-router-dom';
import DocumentBoxesComponent from './DocumentationNew';
import OffersWidgets from '../Offers/OffersWidgets';
import axios from 'axios';
import env from '../../../environment';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const { Text } = Typography;
const { Panel } = Collapse;
const Documentation = ({
	userMortgageId,
	openCollapse,
	handleChangeCollapse,
	docsNumber,
	setDocsNumber
}) => {
	const navigate = useNavigate();
	let { operationId, stage } = useParams();
	const userToken = useSelector((state) => state.auth.token);
	const { t } = useTranslation();
	const [offers, setOffers] = useState(undefined);

	useEffect(() => {
		window.scrollTo(1, 0);

		if (stage === 'documents' || stage === 'basic') {
			navigate(`/operations/${userMortgageId}/documents`);
		} else if (stage === 'analysis') {
			navigate(`/operations/${userMortgageId}/analysis`);
		} else if (stage === 'banks') {
			navigate(`/operations/${userMortgageId}/banks`);
		}

		getOffers();
	}, []);

	const getOffers = () => {
		axios
			.get(`${env.api.url}/v1/banks/get-operation-bank-offers/${operationId}`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setOffers(response.data.data);
			})
			.catch((error) => {
				console.log(error);
			});
	};

	return (
		<>
			<div
				style={{
					backgroundColor: '#fff',
					display: 'flex',
					justifyContent: 'center',
					borderRadius: 4
				}}>
				<Collapse
					accordion
					style={{
						width: isMobileOnly ? '100%' : 'calc(100% - 48px)',
						border: 'none'
					}}
					className={`collapse-doc ${stage === 'documents' ? 'red-arrow' : ''}`}
					defaultActiveKey={stage === 'documents' || stage === 'analysis' ? ['1'] : undefined}
					activeKey={openCollapse[1] ? '1' : undefined}
					onChange={() => handleChangeCollapse('1')}
					expandIconPosition={'end'}>
					<Panel
						key="1"
						header={
							<Space
								style={{ width: '100%', justifyContent: 'space-between' }}
								tabIndex={0}
								className="tab-focus">
								<Text>{t('stages.documents')}</Text>
								{docsNumber === undefined ? (
									<div style={{ width: isMobileOnly ? 100 : 150, marginTop: -10 }}>
										<Skeleton active paragraph={{ rows: 1, width: '100%' }} title={false} />
									</div>
								) : (
									docsNumber > 0 && (
										<Text
											style={{
												fontSize: 12,
												fontWeight: 600,
												color: stage === 'documents' ? '#BE0028' : '#212121'
											}}>
											{isMobileOnly ? (
												<div>
													{docsNumber}{' '}
													{docsNumber === 1 ? t('doc.pendingDocBrev') : t('doc.pendingDocsBrev')}{' '}
												</div>
											) : (
												<>
													{stage === 'documents' ? (
														<div>
															{docsNumber}{' '}
															{docsNumber === 1
																? t('doc.pendingNeededDoc')
																: t('doc.pendingNeededDocs')}{' '}
														</div>
													) : (
														<div>
															{docsNumber}{' '}
															{docsNumber === 1
																? t('doc.pendingOptionalDoc')
																: t('doc.pendingOptionalDocs')}
														</div>
													)}
												</>
											)}
										</Text>
									)
								)}
							</Space>
						}>
						<div style={{ marginTop: -20 }}>
							<DocumentBoxesComponent
								userMortgageId={userMortgageId}
								stage={stage}
								setDocsNumber={setDocsNumber}
							/>
						</div>
					</Panel>
				</Collapse>
			</div>

			{offers !== undefined && offers?.length > 0 ? (
				<OffersWidgets openCollapse={openCollapse} handleChangeCollapse={handleChangeCollapse} />
			) : (
				<div
					style={{ marginTop: isMobileOnly ? 8 : 16 }}
					className={`collapse-offer collapse-offer-close ${
						isMobileOnly ? 'collapse-offer-mobile' : ''
					}`}>
					<Collapse
						accordion
						style={{ width: '100%', border: 'none' }}
						className={offers?.length > 0 ? 'blue-arrow' : ''}
						defaultActiveKey={
							stage === 'appraisal' ||
							stage === 'formalization' ||
							stage === 'documents' ||
							stage === 'analysis'
								? undefined
								: ['1']
						}
						activeKey={openCollapse[2] ? ['1'] : undefined}
						onChange={() => handleChangeCollapse('2')}
						expandIconPosition={'end'}>
						<Panel
							key="1"
							header={
								<Space
									style={{ width: '100%', justifyContent: 'space-between' }}
									tabIndex={0}
									className="tab-focus">
									<Text>{t('m_offers.title')}</Text>
									{offers?.length > 0 && (
										<Text style={{ fontSize: 14, fontWeight: 600, color: '#006DFF' }}>
											{offers?.length + ' '}
											{offers?.length > 1 ? t('doc.offers') : t('doc.offer')}
										</Text>
									)}
								</Space>
							}>
							<div>
								{stage === 'documents' && (
									<Text style={{ fontSize: 16, fontWeight: 400, color: '#212121' }}>
										{t('doc.toReceiveYourOffer')}{' '}
										<span
											style={{ color: '#006DFF', fontWeight: 700, cursor: 'pointer' }}
											onClick={() => handleChangeCollapse('1')}>
											{t('doc.needDocs')}
										</span>
									</Text>
								)}
								{(stage === 'analysis' || stage === 'banks') && (
									<Text style={{ fontSize: 16, fontWeight: 400, color: '#212121' }}>
										{t('doc.analyzingDocs')}{' '}
										<span style={{ fontWeight: 700 }}>{t('doc.receiveYourOffer')}</span>
									</Text>
								)}
							</div>
						</Panel>
					</Collapse>
				</div>
			)}
		</>
	);
	// }
};

export default Documentation;
